<template>
  <section class="section-aboutUs">
    <div class="container">
      <div class="section-space-50"></div>

      <div class="row">
        <div
          class="
            col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6
            mb-4 mb-md-5
            order-2 order-md-1
          "
        >
          <div class="d-md-block">
            <div class="about-us-title">About Us</div>
            <p>
            Established in 1987, Miraj Group which is now a leading business brand with multiple business verticals including Tobacco, FMCG, Pipes & Fittings, Stationery & Infra-Development. In the year 2010 Miraj Group ventured into producing movies & later ventured in Cinema Exhibition business in the year 2012.
          </p>

          <p>
            Miraj Cinemas' screen count has multiplied immensely and we proudly own 176 screens across 43 cities and 15 states in India. By the end of 2022, we aim to have 200+ screens.
          </p>
          </div>

          <!-- <div v-html="about_us"></div> -->
        </div>

        <div
          class="
            col-12 col-sm-12 col-md-10 col-lg-6 col-xl-6
            mx-auto
            mb-4 mb-md-5
            order-1 order-md-2
          "
        >
          <!-- <div class="about-us-title d-md-none">About Us</div> -->

          <slick :options="aboutUsSlider">
            <div>
              <img
                src="@/assets/img/aboutUsImages/Jaipur_Cinema-1.jpg"
                class="img-fluid rounded p-2 d-table"
                alt
              />
            </div>
            <div>
              <img
                src="@/assets/img/aboutUsImages/Jaipur_Cinema-2.jpg"
                class="img-fluid rounded p-2 d-table"
                alt
              />
            </div>
            <div>
              <img
                src="@/assets/img/aboutUsImages/ab_.jpg"
                class="img-fluid rounded p-2 d-table"
                alt
              />
            </div>
            <div>
              <img
                src="@/assets/img/aboutUsImages/Jaipur_Cinema-4.jpg"
                class="img-fluid rounded p-2 d-table"
                alt
              />
            </div>
          </slick>

        </div>

        <div
          class="col-12 col-sm-12 col-md-10 mx-auto col-lg-6 col-xl-6 mb-4 mb-md-5 order-3 order-md-4 order-lg-3"
        >
          <div class="text-center mx-auto">
            <slick :options="aboutUsSlider">
              <div>
                <img
                  src="@/assets/img/aboutUsImages/About_1.jpg"
                  class="img-fluid rounded p-2 d-table"
                  alt
                />
              </div>
              <!-- <div>
                <img
                  src="@/assets/img/aboutUsImages/About_2.jpg"
                  class="img-fluid rounded p-2 d-table"
                  alt
                />
              </div> -->
              <div>
                <img
                  src="@/assets/img/aboutUsImages/About_3.jpg"
                  class="img-fluid rounded p-2 d-table"
                  alt
                />
              </div>
            </slick>
          </div>
        </div>

        <div
          class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-4 mb-md-5 order-4 order-md-3 order-lg-4"
        >
          <div class="d-md-block"><div class="about-us-title">Awards</div></div>
          <p>
            Our multiplex chain has received several awards and recognition
            which includes ET Business Awards for the Most Admired Multiplex of
            the year, Best Picture & Sound Quality, Emerging Cinema Chain in
            India to name a few.
          </p>

          <p>
            Our goal is to provide an exciting and luxurious cinematic
            experience to our audience, so they return with a smile on their
            face.
          </p>
        </div>

        <div
          class="
            col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12
            mb-4 mb-md-5
            order-4
          "
        >
          <!-- <p>
            Want to advertise with us?
            <router-link
              class="text-rose-gold"
              @click.native="() => $router.push({ name: 'Advertise With Us' })"
              to
              >Click here</router-link
            >
          </p> -->
        </div>
      </div>
      <div class="section-space-50"></div>
    </div>
  </section>
</template>
<script>
import ExtrasServices from "@/apiServices/ExtrasService";

export default {
  data() {
    return {
      about_us: null,
      aboutUsSlider: {
        dots: false,
        arrows: true,
        slidesToShow: 1,
      },
    };
  },
  methods: {
    async getAboutUs() {
      try {
        const response = await ExtrasServices.getAboutUs();
        if (response.data.status) {
          this.about_us = response.data.data.extra_html_content;
        }
      } catch (err) {
        console.log("Error in getting about us ", err);
      }
    },
  },
  beforeMount() {
    this.getAboutUs();
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/aboutUs.vue